module.exports = __webpack_public_path__ + "img/about.868e308d.jpg";